<script>
  import { onMount } from "svelte";
  import { pwaDeferredPrompt } from "../utils/pwdStore";

  let deferredPrompt;
  let btnInstallAppVisible = false;

  onMount(() => {
    if ($pwaDeferredPrompt !== null) {
      deferredPrompt = $pwaDeferredPrompt;
      btnInstallAppVisible = true;
    }
  });

  function installApp(event) {
    deferredPrompt = $pwaDeferredPrompt;
    deferredPrompt.prompt();
    deferredPrompt.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === "accepted") {
        btnInstallAppVisible = false;
        pwaDeferredPrompt.update((s) => null);
        console.log("User accepted the prompt");
      } else {
        console.log("User dismissed the prompt");
      }
    });
  }
</script>

<div
  class="text-white border-white rounded-xl bg-gray-800 p-2 flex flex-col "
  class:hidden={!btnInstallAppVisible}
>
  <p>You can add CrossFitTimers to the home screen</p>
  <button
    on:click={installApp}
    class="self-start bg-red-600 text-white py-2 px-4 rounded-full focus:outline-none transform hover:scale-105 focus:scale-105 transition duration-100 ease-in-out active:text-gray-300"
  >
    Install
  </button>
</div>
